<template>
  <div>
    <section class="justify-between flex-none max-w-4xl p-8 m-auto mt-12 md:flex pv-12">
      <template v-if="result.type === 'album'">
        <aside class="w-full p-8 md:w-auto">
          <img alt="Album Cover" :src="result.image" />
        </aside>
        <article class="w-full md:w-1/2">
          <h3 class="text-lg">Album</h3>
          <h1 class="text-5xl md:-ml-4">{{ result.album }}</h1>
          <h3 class="text-lg">{{ result.year }}</h3>
          <h3 class="text-xl">{{ result.artist }}</h3>
          <h3 class="text-lg">{{ result.genre }}</h3>
          <p class="mt-4 mb-20 text-base" v-html="result.description"></p>
        </article>
      </template>
      <template v-if="result.type === 'film'">
        <aside class="w-full p-8 md:w-auto">
          <img alt="Movie Poster" :src="result.image" />
        </aside>
        <article class="w-full md:w-2/3">
          <h3 class="text-lg">Film</h3>
          <h1 class="text-5xl md:-ml-4">{{ result.title }}</h1>
          <h3 class="text-lg">{{ result.year }}</h3>
          <h3 class="text-xl">{{ result.director }}</h3>
          <h3 class="text-lg">{{ result.genre }}</h3>
          <p class="mt-4 mb-20 text-base" v-html="result.description"></p>
        </article>
      </template>
    </section>
    <div class="fixed bottom-0 w-full p-4 m-auto text-center bg-orange-300 t-center">
      <button v-on:click="getResult" class="m-auto underline">Try something else?</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: "RandomChooser",
  data() {
    return {
      result: {}
    }
  },
  mounted() {
    this.getResult();
  },
  methods: {
    async getResult() {
      try {
        const response = await axios.post("https://15umsr51e6.execute-api.us-east-1.amazonaws.com/dev/any");
        this.result = response.data;
      } catch (e) {
        console.error(e)
      }
    }
  }
};
</script>
